// Trong file create-ticket-from-excel.api.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from 'utils/base-api';

export const createTicketFromExcelApi = createApi({
    reducerPath: 'createTicketFromExcelApi',
    tagTypes: [],
    baseQuery: axiosBaseQuery,
    endpoints: (builder) => ({
        createTicketsFromExcel: builder.mutation<any, FormData>({
            query: (formData) => ({
                url: 'tickets/dtv/create_ticket_from_excel',
                method: 'POST',
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }),
        }),
    }),
});

export const { useCreateTicketsFromExcelMutation } = createTicketFromExcelApi;